import React, { useEffect, useState } from 'react';
import styles from './Dashboard.module.css';
import apiService from '../api/apiService';

// Data array for statistics
/* const stats = [
  { sublabel: "Today's", label: 'Check-in', value: '23' },
  { sublabel: "Today's", label: 'Check-out', value: '13' },
  { sublabel: 'Total', label: '', value: '60' },
  { sublabel: 'Total', label: 'Available room', value: '10' },
  { sublabel: 'Total', label: 'Occupied room', value: '90' },
]; */

export const Statistics = ({ hotelId }) => {
  const [stats, setStats] = useState([
    { sublabel: "Today's", label: 'Check-in', value: '0' },
    { sublabel: "Today's", label: 'Check-out', value: '0' },
    { sublabel: 'Total', label: 'Guests', value: '0' },
    { sublabel: 'Total', label: 'Available room', value: '0' },
    { sublabel: 'Total', label: 'Occupied room', value: '0' },
  ]);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      // Fetch bookings data
      const bookingsRes = await apiService.get(`/bookings/?hotel=${hotelId}`);

      const today = new Date().toDateString();

      const checkInsToday = bookingsRes.filter(
        booking =>
          new Date(booking.check_in).toDateString() === today &&
          booking.status === 'confirmed'
      ).length;

      const checkOutsToday = bookingsRes.filter(
        booking =>
          new Date(booking.check_out).toDateString() === today &&
          booking.status === 'check_out'
      ).length;

      // Fetch rooms data
      const roomsRes = await apiService.get(`/rooms/?hotel=${hotelId}`);
      const totalRooms = roomsRes.length;
      const occupiedRooms = roomsRes.filter(
        room => room.status === 'occupied'
      ).length;
      const availableRooms = totalRooms - occupiedRooms;

      // Fetch guests data (FIXED)
      const guestsRes = await apiService.get(`/guests/?hotel=${hotelId}`);
      const totalGuests = guestsRes.length;

      // Update statistics
      setStats([
        {
          sublabel: "Today's",
          label: 'Check-in',
          value: checkInsToday.toString(),
        },
        {
          sublabel: "Today's",
          label: 'Check-out',
          value: checkOutsToday.toString(),
        },
        {
          sublabel: 'Total',
          label: 'Guests',
          value: totalGuests.toString(),
        },
        {
          sublabel: 'Total',
          label: 'Available room',
          value: availableRooms.toString(),
        },
        {
          sublabel: 'Total',
          label: 'Occupied room',
          value: occupiedRooms.toString(),
        },
      ]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <section
      className={`${styles.statistics} container`}
      aria-label="Hotel Statistics"
    >
      <div className="row w-100 justify-content-around">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`col-6 col-sm-4 col-md-auto mb-3 ${styles.statCard}`}
          >
            <div className={styles.statLabel}>{stat.sublabel}</div>
            <div className={styles.statType}>{stat.label}</div>
            <div className={styles.statValue}>{stat.value}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
